import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DepartMentService } from 'src/app/private/services/department.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-delete-department',
  imports: [SharedModule],
  templateUrl: './delete-department.component.html',
  styleUrl: './delete-department.component.scss'
})
export class DeleteDepartmentComponent {
  @Input() departmentDataToEdit: any = null;
  @Input() clientId: string = '';
  isLoading = false;

  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  constructor(
    private deptService: DepartMentService, // Assuming DepartMentService has deleteCampus method
    private messageService: MessageService
  ) { }


  handleCloseDialog() {
    this.close.emit();
  }

  handleDeleteDepartment() {
    this.isLoading = true; // Set loading state to true
    const payload = {
      dept_id: this.departmentDataToEdit.dept_id,
      clientId: this.clientId
    };
    this.deptService.deleteDepartment(payload).subscribe(
      {
        next: (res: any) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Department deleted successfully'
          });
          this.reload.emit(); // Emit reload event to parent component
          this.close.emit(); // Emit close event to parent component
        },
        error: (err) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.error?.message || 'An error occurred while deleting the department'
          });
        }
      }
    );
  }

}
